import React from 'react';

const Farmer = () => {
  return (



    <section id='OurProgram'>
      <div className='flex flex-col w-full items-center mt-12 mb-12'>
        <h1 className='mt-5 text-green-600 font-bold text-center  text-5xl md:text-6xl lg:text-8xl'>AMING MGA PROGRAMA</h1>
        <div className='grid grid-cols-1 p-3 md:grid-cols-4 grid-rows-2 gap-4 mt-10 m-8 '>
          {/* Cards */}
          <div className='bg-white rounded-xl shadow-2xl mt-10 p-10'>
            <div className='flex justify-center  text-green-600'>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <div class="flex p-8 flex-col">
              <h3 class="font-bold md:text-2xl sm:text-lg text-center text-green-700 mb-5">LOANS WITH LOW INTEREST RATES</h3>
              <p className='max-w-md sm:text-lg md:text-xl'>
                <ol class='list-disc'>
                  <li>Low interest (1.5% interest/month)</li>
                  <li>Receive funding for every product</li>
                  <li className='text-sm mr-2 py-2 italic list-none'>Rice - Maximum of PHP 100,000/hectare</li>
                  <li className='text-sm mr-2 py-2 italic list-none'>Corn - Maximum of PHP 100,000/hectare</li>
                  <li className='text-sm mr-2 py-2 italic list-none '>Onion - Up to 250,000/hectare</li>
              
                  <li>No collateral needed</li>
                  <li>Use your produce to pay back</li>
                  <li>Fast processing</li>
                  <li>No hidden fees</li>
                </ol>
              </p>

            </div>
          </div>
          <div className='bg-white rounded-xl shadow-2xl mt-10 p-10'>
            <div className='flex justify-center  text-green-600'>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div class="flex p-8 flex-col">
              <h3 class="font-bold md:text-2xl sm:text-lg text-center text-green-700 mb-5">LOW PRICES OF SUPPLIES AND TOOLS</h3>
              <p className='max-w-md sm:text-lg md:text-xl'>
                <ol class='list-disc'>
                  <li>Buy tools and supplies at low prices online.</li>
                  <li>Receive purchases at the nearest warehouse.</li>
                </ol>
              </p>

            </div>
          </div>
          <div className='bg-white rounded-xl shadow-2xl mt-10 p-10'>
            <div className='flex justify-center  text-green-600'>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
              </svg>
            </div>
            <div class="flex p-8 flex-col">
              <h3 class="font-bold md:text-2xl sm:text-lg text-center text-green-700 mb-5">	FAIR MARKET PRICES</h3>
              <p className='max-w-md sm:text-lg md:text-xl'>
                <ol class='list-disc'>
                  <li>Sell your produce at the best prices</li>
                  <li>Know the latest market prices</li>
                </ol>
              </p>

            </div>
          </div>
          <div className='bg-white rounded-xl shadow-2xl mt-10 p-10'>
            <div className='flex justify-center  text-green-600'>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <div class="flex p-8 flex-col">
              <h3 class="font-bold md:text-2xl sm:text-lg text-center text-green-700 mb-5">POST-HARVEST FACILITIES</h3>
              <p className='max-w-md sm:text-lg md:text-xl'>
                <ol class='list-disc'>
                  <li>Places to sell your produce</li>
                  <li>Warehouses to receive supplies and tools.</li>
                  <li>Multi-Purpose Drying Pavement (MPDP) </li>
                  <li>Milling Production Facility</li>
                </ol>
              </p>

            </div>
          </div>
          <div className='bg-white rounded-xl shadow-2xl mt-10 p-10'>
            <div className='flex justify-center  text-green-600'>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <div class="flex p-8 flex-col">
              <h3 class="font-bold md:text-2xl sm:text-lg text-center text-green-700 mb-5">MECHANIZED FARMING</h3>
              <p className='max-w-md sm:text-lg md:text-xl'>
                <ol class='list-disc'>
                  <li>Reduce labor cost</li>
                  <li>Increase productivity with less effort</li>
                  <li>Easy access to renting available machinery </li>
                </ol>
              </p>

            </div>
          </div>
          <div className='bg-white rounded-xl shadow-2xl mt-10 p-10'>
            <div className='flex justify-center  text-green-600'>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <div class="flex p-8 flex-col">
              <h3 class="font-bold md:text-2xl sm:text-lg text-center text-green-700 mb-5">Crop Insurance</h3>
              <p className='max-w-md sm:text-lg md:text-xl'>
                <ol class='list-disc'>
                  <li>Automatic insurance to protect your crops from losses due to natural disasters and more.</li>
                </ol>
              </p>

            </div>
          </div>
          <div className='bg-white rounded-xl shadow-2xl mt-10 p-10'>
            <div className='flex justify-center  text-green-600'>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
              </svg>
            </div>
            <div class="flex p-8 flex-col">
              <h3 class="font-bold md:text-2xl sm:text-lg text-center text-green-700 mb-5">MODERN FARMING KNOWLEDGE</h3>
              <p className='max-w-md sm:text-lg md:text-xl'>
                <ol class='list-disc'>
                  <li>Continuous research and dissemination of information by the Municipal Agriculuture of LGU of Bayambang</li>
                  <li>GEOGRAPHICAL INFORMATION SYSTEM (GIS) at SOIL ANALYSIS pinpoints every location in Bayambang, soil type, and top harvested crops.</li>
                </ol>
              </p>

            </div>
          </div>

        </div>
      </div>
    </section>

  );
};

export default Farmer;
